var map = {
	"./icon-flag-de.svg": "e027",
	"./icon-flag-en.svg": "cead",
	"./icon-flag-fr.svg": "592b",
	"./icon-flag-pl.svg": "f2be",
	"./icon-flag-pt.svg": "7273",
	"./icon-flag-ro.svg": "0cdf",
	"./icon-flag-ua.svg": "8942"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "40bc";